/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';
import { TourResource } from '../model/models';
import { TourStatusRequest } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface TourStatusServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Update status
     * 
     * @param tour The tour ID
     * @param tourStatusRequest 
     */
    updateTourStatus(tour: number, tourStatusRequest: TourStatusRequest, extraHttpRequestParams?: any): Observable<TourResource>;

}
